import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import { useUserContext } from '../hooks';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const userConsumer = useUserContext();
  const isLoggedIn = userConsumer.user && userConsumer.user.loggedIn && !userConsumer.user.passwordUpdateRequired;
  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.object,
};

export default PrivateRoute;
